import legacyUtils from './utils';

const validHttpStatuses = [200, 201, 202, 204];

const jsonContentEncoder = {
  contentType: 'application/json; charset=utf-8',
  encode: function (body) {
    return JSON.stringify(body);
  },
};

const formContentEncoder = {
  contentType: 'application/x-www-form-urlencoded; charset=utf-8',
  encode: function (body) {
    return legacyUtils.serializeFormObject(body);
  },
};

function getContentEncoder(contentType) {
  let encoder = jsonContentEncoder;

  if (contentType && contentType.indexOf('application/x-www-form-urlencoded') === 0) {
    encoder = formContentEncoder;
  }

  return encoder;
}

class MakeHttpRequestError extends Error {
  type: string;
  status: number;

  constructor(message: string, type: string, status: number) {
    super(message);
    this.type = type;
    this.status = status;
  }
}

function makeHttpRequest(method, uri, body, headers, callback) {
  const request = new XMLHttpRequest();

  request.open(method.toUpperCase(), uri, true);

  if (headers) {
    for (const name in headers) {
      if (name === 'Content-Type') {
        continue;
      }

      request.setRequestHeader(name, headers[name]);
    }
  }

  request.withCredentials = true;

  request.onreadystatechange = function () {
    if (request.readyState !== 4) {
      return;
    }

    const result = {
      status: request.status,
      responseJSON: null,
    };

    let caughtError;

    try {
      if (request.responseText) {
        result.responseJSON = JSON.parse(request.responseText);
      }
    } catch (e) {
      caughtError = e;
    }

    if (caughtError) {
      return callback(caughtError);
    }

    return callback(null, result);
  };

  if (body && typeof body === 'object') {
    const contentEncoder = getContentEncoder(headers['Content-Type']);
    request.setRequestHeader('Content-Type', contentEncoder.contentType);
    request.send(contentEncoder.encode(body));
  } else {
    request.send();
  }
}

const defaultEndpoints = {
  baseUri: null,
};

export default class BaseService {
  endpoints: any;
  forceAgentHeader: boolean;

  constructor(endpoints, forceAgentHeader) {
    this.endpoints = legacyUtils.mergeObjects(defaultEndpoints, endpoints);
    this.forceAgentHeader = forceAgentHeader || false;
  }

  _makeRequest(method, path, body, headers, callback) {
    const uri = this._buildEndpoint(path);
    headers = headers || {};

    if (!headers.Accept) {
      headers.Accept = 'application/json';
    }

    makeHttpRequest(method, uri, body, headers, function (err, result) {
      if (err) {
        return callback(err);
      }

      const data = result.responseJSON || {};

      if (validHttpStatuses.includes(result.status)) {
        return callback(null, data);
      }

      const error = new MakeHttpRequestError(
        data.message || data.error || 'A request to the API failed.',
        data.error,
        result.status,
      );

      return callback(error);
    });
  }

  _buildEndpoint(endpoint) {
    return (this.endpoints.baseUri || '') + endpoint;
  }
}
